import { useEffect, useState } from 'react';
import 'moment-timezone'
import { TextService } from '../../Services/TextService';
import { DocumentService } from '../../Services/ImageService';
import { BlobDto } from '../../Repository/eventbookyapi';
import { Table } from 'antd';
import LeftMenuSettings from './LeftSettings';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import Paragraph from 'antd/es/typography/Paragraph';
import { FileExcelOutlined } from '@ant-design/icons';
import { formatDateString } from '../../Helpers/DateHelpers';


const Backups = () => {
    const [backup, setBackupFiles] = useState([] as BlobDto[]);

    const GetText = TextService.GetText;

    useEffect(() => {
        DocumentService.GetBackupFiles().then(companyFiles => {
            setBackupFiles(companyFiles);
        })

    }, []);

    const handleDownload = async (file: BlobDto) => {
        const data = await DocumentService.GetFile(file.relativeUri!, file.contentType!);
        const url = window.URL.createObjectURL(await data.raw.blob());
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name!);
        document.body.appendChild(link);
        link.click();
    };


    const columns = [
        {
            title: GetText("Backup_FileName"),
            dataIndex: 'fileName',
            key: 'fileName',
            render: (text: any, record: BlobDto) => (
                <a onClick={() => handleDownload(record)}> <FileExcelOutlined /> {record.name?.split("/").pop()}</a>
            ),
        },
        {
            title: GetText("Backup_Date"),
            dataIndex: 'date',
            key: 'date',
            render: (text: any, record: BlobDto) => (
                <span> {formatDateString(record.lastModified)}</span>
            ),
        },
        {
            title: GetText("Backup_Size"),
            dataIndex: 'size',
            key: 'size',
            render: (text: any, record: BlobDto) => (
                <span> {record.size && record.size > 0 ? record.size / 1000 : 0} kB</span>
            ),
        },
    ];

    return <LayoutLeftMenu title={GetText("Backup_BackupTitle")} menu={<LeftMenuSettings selected={"backup"} />}>
        <Paragraph>{GetText("Backup_BackupDescription")}</Paragraph><br />
        {
            backup != null ? <>


                <Table
                    columns={columns}
                    dataSource={backup}
                    rowKey="fileName"
                    locale={{ emptyText: GetText("Backup_NoFiles") }}
                />            </>
                : <i>{GetText("Backup_NoBackupFound")}</i>
        }
    </LayoutLeftMenu>
};


export default Backups;